import { inject, Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { CalendarGetQuery, CalendarGetQueryResult } from "../../INTEGRA_Shop_Client";
import { ICalendarService, ICalendarServiceToken } from "./calendar-service.interface";
import { ICalendarApiService, ICalendarApiServiceToken } from "../../api/calendar/calendar-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class CalendarService implements ICalendarService {

  private readonly calendarApiService: ICalendarApiService;

  public constructor() {
    this.calendarApiService = inject(ICalendarApiServiceToken);
  }

  public calendarGet(fromDate: Date, toDate: Date, countryCode: string): Observable<CalendarGetQueryResult> {
    let query = new CalendarGetQuery();
    query.fromDate = fromDate;
    query.toDate = toDate;
    query.countryCode = countryCode;

    return this.calendarApiService.calendarGet(query);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CalendarServiceProvider: Provider[] = [
  { provide: ICalendarServiceToken, useExisting: CalendarService }
];
